import { ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2, RendererFactory2, inject } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { MentionMePlace, TMentionMeImplementation, TMentionMeSituation } from '@df/module-mention-me/mention-me.interfaces';
import { MentionMeService } from '@df/module-mention-me/mention-me.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { Nexus } from '@tomandco/nexus-api-types';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export class MentionMeWrapperComponentDef implements OnChanges, OnDestroy {
    /**
     * Mention Me ID
     */
    @Input()
    mmid?: string;

    /**
     * Place where it was implemented
     */
    @Input()
    place?: MentionMePlace;

    /**
     * Situation where it was implemented
     * Values: any, for example: checkout | homepage | landingpage | dashboard
     */
    @Input()
    situation?: TMentionMeSituation;

    /**
     * Allows to override default visual representation of the widget
     * Values: leave empty for default or one of: embed | popup | banner | overlay | link
     */
    @Input()
    implementation?: TMentionMeImplementation;

    /**
     * Any data that might be needed, depends on place
     */
    @Input()
    checkoutSuccessData?: Nexus.Api.Checkout.Success.ISuccessData;

    private renderer = inject(Renderer2);

    private triggerWidgetDebounced: () => void;

    constructor(
        private mentionMe: MentionMeService,
        private app: App,
        private element: ElementRef,
        private changeDetectorRef: ChangeDetectorRef,
        private rendererFactory: RendererFactory2,
        private timeoutService: TimeoutService
    ) {
        this.triggerWidgetDebounced = this.timeoutService.debounce(() => this.triggerWidget());
    }

    ngOnChanges() {
        this.triggerWidgetDebounced();
    }

    ngOnDestroy(): void {
        if (window.MentionMeFiredTags) {
            window.MentionMeFiredTags = false;
        }
    }

    private triggerWidget(): void {
        this.app.customer.model.load().finally(() => {
            const url = this.mentionMe.getQuery(this.place!, this.mmid!, this.implementation, this.situation, this.checkoutSuccessData);
            if (url) {
                const element = this.getElement();
                const script = this.renderer.createElement('script');
                this.renderer.setProperty(script, 'src', url);
                this.renderer.setProperty(script, 'type', 'text/javascript');
                const wrapper = element.querySelector('#mmWrapper');
                if (wrapper) {
                    wrapper.appendChild(script);
                }
            }
            this.detectChanges();
        });
    }

    private getElement(): HTMLElement {
        return this.element.nativeElement;
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
